import React from "react";

import { Badge, Button, ListGroup, ListGroupItem, Modal } from "react-bootstrap";
import Select from "react-select";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDatabase, faPlus, faExclamationTriangle, faUpload } from "@fortawesome/free-solid-svg-icons";

import AibleStep from "components/CreateWizard/AibleStep";
import TableLoader, { TableColumn, TableRow } from "components/Table/Table.js";

import styles from "./style.module.css";

export default class ChooseColumns extends React.PureComponent {
  state = {
    selectedField: undefined
  };

  handleSelectField(field) {
    const { selectedField } = this.state;

    return this.setState({
      selectedField: selectedField ? (selectedField.label === field.label ? undefined : field) : field
    });
  }

  renderTable() {
    const { dataset, isIgnored, ignored, ignoredValue, updateIgnored } = this.props;
    const { selectedField } = this.state;

    const headers = ["Field", "Type", "Warnings"];

    const rows = Object.keys(dataset.fields).map((fKey, index) => {
      const field = dataset.fields[fKey];
      const isOutcome = dataset.outcome === field.label;

      const data = [
        field.label,
        field.type,
        field.warnings ? (field.warnings.length === 0 ? "" : field.warnings.length) : ""
      ];

      return {
        row: (
          <TableRow
            key={index + "_" + (selectedField ? selectedField.label : "")}
            className={
              styles.fieldRow +
              " " +
              (selectedField && selectedField.label === field.label ? styles.selectedFieldRow : "")
            }
          >
            <TableColumn>
              <a onClick={() => this.handleSelectField(field)}>{data[0]}</a>
              {isOutcome && <Badge className={styles.outcomeBadge}>{"Outcome"}</Badge>}
            </TableColumn>
            <TableColumn>
              <div className={styles.capitalize}>{data[1]}</div>
            </TableColumn>
            <TableColumn>
              <a onClick={() => this.handleSelectField(field)}>{data[2]}</a>
            </TableColumn>
          </TableRow>
        ),
        data: data
      };
    });

    return dataset && dataset.fields ? (
      <div className={styles.table} style={{ width: selectedField ? "60%" : "100%" }}>
        <TableLoader headers={headers} rows={rows} />
      </div>
    ) : (
      <div />
    );
  }

  renderValueTable() {
    const { ignoredValue, updateIgnoredValue } = this.props;
    const { selectedField } = this.state;

    const hasWarnings = selectedField && selectedField.warnings && selectedField.warnings.length > 0;
    const isCategory = selectedField && selectedField.data;
    const isNumber = selectedField && selectedField.min !== undefined;

    const headers = isCategory ? ["Value", "Count"] : isNumber ? ["Field", "Min", "Max"] : [];
    const rows = isCategory
      ? selectedField.data.map((value, index) => {
          return {
            data: [value.value, value.count],
            row: (
              <TableRow key={index}>
                <TableColumn>{value.value}</TableColumn>
                <TableColumn>{value.count}</TableColumn>
              </TableRow>
            )
          };
        })
      : isNumber
        ? [
            {
              data: [selectedField.label, selectedField.min, selectedField.max],
              row: (
                <TableRow key={0}>
                  <TableColumn>{selectedField.label}</TableColumn>
                  <TableColumn>{selectedField.min}</TableColumn>
                  <TableColumn>{selectedField.max}</TableColumn>
                </TableRow>
              )
            }
          ]
        : [];

    return (
      <div
        className={styles.valueTable}
        style={{
          width: selectedField ? "calc(40% - 10px)" : "0%"
        }}
      >
        <div
          className={styles.vHolder}
          style={{
            maxHeight: hasWarnings ? "250px" : "500px"
          }}
        >
          {isCategory || isNumber ? (
            <TableLoader headers={headers} rows={rows} paddingBottom={250} selectedField={selectedField} />
          ) : (
            <div />
          )}
        </div>
        {hasWarnings ? (
          <div className={styles.warningHolder}>
            {selectedField.warnings.map((w, index) => (
              <div className={styles.warning} key={index}>
                <div className={styles.warningIcon}>
                  <FontAwesomeIcon icon={faExclamationTriangle} />
                </div>
                <div className={styles.warningText}>{w.message}</div>
              </div>
            ))}
          </div>
        ) : (
          <div />
        )}
      </div>
    );
  }

  render() {
    const { dataset, ignored, isContinuous } = this.props;
    const { selectedField, showTable } = this.state;

    if (dataset === undefined) {
      return <div />;
    }

    return (
      <div className={styles.dcBody}>
        <div className={styles.tables}>
          {this.renderTable()}
          {this.renderValueTable()}
        </div>
      </div>
    );
  }
}
